import PropTypes from 'prop-types';

const WideTextFormatter = ({ text }) => (
  <span
    title={text}
    style={{
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }}
  >
    {text}
  </span>
);

WideTextFormatter.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.null]),
};

export default WideTextFormatter;
